import Panel from "./Panel";
import MetaRow from "./MetaRow";

/* ── 04 · Winner Detector ── */
const WinnerDetectorMock = () => {
  const tests = [
    {
      v: "A",
      t: "Test #2 · Carousel routine flow",
      hash: "#2",
      roas: "2.94×",
      w: "92%",
    },
    {
      v: "C",
      t: "Test #6 · UGC creator unbox",
      hash: "#6",
      roas: "2.66×",
      w: "78%",
    },
    {
      v: "A",
      t: "Test #9 · 9-sec vertical edit",
      hash: "#9",
      roas: "2.41×",
      w: "64%",
    },
    {
      v: "B",
      t: "Test #11 · Founder-led monologue",
      hash: "#11",
      roas: "2.28×",
      w: "55%",
    },
  ];
  return (
    <Panel>
      <MetaRow
        dot="#5BD78C"
        label="Active tests · 4 winners ready"
        right="Scanned · 15M"
      />
      <hr className="border-white/10 " />
      {/* featured winner */}
      <div className="border relative border-[#FFFFFF]  bg-gradient-to-r from-[#D9FF3A1A]/[10%] to-[#D9FF3A05]/[2%] p-3.5">
        <div className="absolute left-3 -top-3">
          <span className="inline-flex items-center gap-1  bg-white px-2 py-1 text-[8px] font-semibold uppercase tracking-wide text-black">
            Winner
          </span>
        </div>
        <div className="mt-2.5 flex items-start justify-between gap-2 sm:gap-3">
          <div className="flex min-w-0 items-start gap-2.5 sm:gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center bg-[#6FA4FF] text-[18px] font-semibold text-white sm:h-16 sm:w-16 sm:text-[24px]">
              B
            </div>
            <div className="min-w-0 flex-1">
              <span className="text-[10px] font-medium uppercase tracking-[0.14em] text-[#A59881]">
                — Just surfaced
              </span>

              <p className="break-words font-serif text-[14px] italic text-white sm:text-[16px]">
                Test #4 · “Why your serum isn’t working”
              </p>

              <p className="mt-1 break-words text-[11px] leading-[1.45] text-[#A09AAF]">
                Outperformed control by 87% on ROAS. Ready to scale.
              </p>
            </div>
          </div>
          <div className="flex shrink-0 flex-col items-end">
            <span className="font-serif text-[24px] italic leading-none text-white sm:text-[30px]">
              94%
            </span>
            <span className="mt-0.5 text-[10px] uppercase tracking-[0.12em] text-[#A59881] ">
              Conf.
            </span>
          </div>
        </div>
      </div>

      {/* active tests list */}
      <div className="flex flex-1 flex-col">
        {tests.map((t, i) => (
          <div
            key={i}
            className="flex items-center justify-between gap-3 border-t border-white/10 px-3 py-3"
          >
            <div className="min-w-0 flex  items-center  justify-center gap-3 ">
              <span className="flex h-8 w-8 shrink-0 font-serif italic items-center justify-center bg-[#3A2569] text-[14px] font-bold text-white">
                {t.v}
              </span>
              <p className="truncate text-[12px] font-medium text-white">
                {t.t} <span className="text-[#A59881] ">{t.hash}</span>
              </p>
            </div>
            <div className="flex max-w-[200px] flex-1 items-center gap-2">
              <div className="flex-1">
                <div className="h-1.5 w-full overflow-hidden bg-white/10">
                  <span
                    className="block h-full bg-gradient-to-r from-[#8A5FFF] to-[#FFFFFF]  "
                    style={{ width: t.w }}
                  />
                </div>
              </div>

              <span className="shrink-0 font-serif text-[20px] italic tabular-nums text-white">
                {t.roas}
              </span>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
};

export default WinnerDetectorMock;
